import { Stack, Label, PrimaryButton, DefaultButton, IComboBoxOption, IComboBox, TextField, IContextualMenuItem, initializeIcons, Checkbox, Spinner, SpinnerSize, Dialog, DialogType, IconButton } from '@fluentui/react';
import React, { FormEvent } from 'react';
import { TConfig, TProduct, TSet } from '../constants/types';
import Globals, { CreateSetMenu, GetSets, SetLoggedOut } from '../services/Globals';
import styles from '../styles/pokemon.module.scss';
import Clients from './Clients';
import Connects from './ConnectsComponent';
import Products from './Products';
import ShowToastComponent from './showToastComponent';
import PokemonCards from './cardsComponent';
import Logs from './logsComponent';
import SetManager from './setManagerComponent';
import ProductsComponent from './productsComponent';
import Clientsv2 from './Clientsv2';
import { useNavigate } from 'react-router-dom';
import Styling from './stylingComponent';
import Configuration from './configurationComponent';
import cookie from 'react-cookies';
import EditTags from './editTagsComponent';
import SetManagerV2 from './setManagerV2Component';
import Settings from './settingsComponent';

export interface IaddCardsProps {
    
}

export interface IaddCardsState {
    apiUrl: string;
    username: string;
    token: string;
    eurprice: number;
    setvalue: number;
    sets: TSet[];
    setsCombobox: IComboBoxOption[];
    cardIndex: number;
    cards: TProduct[];
    satprice: number;
    filteredcards: TProduct[];
    saving: boolean;
    selectedSetName: string;
    isDebug: boolean;
    dev: boolean;
    setsMenu: IContextualMenuItem[];
    selectedSetId: number;
    visibleTab: string;
    history: string[];
    invoice: any;
    toastMessage?: string;
    settotalcards: number;
    site: string;
    selectedProduct?: TProduct;
    filter?: string;
    loading: boolean;
    onlyAvailable: boolean;
    newProduct?: TProduct;
    sitemap?: string[];
    routes?: string;
    message?: string;
    errormessage?: string;
    confirmCallback?: Function;
    commission: number;
    showmax: number;
    totalFiltered: number;
    defaultTags: string;
    showFilters: boolean;
};

export default class MainComponent extends React.Component<IaddCardsProps, IaddCardsState> {
    constructor(props: IaddCardsProps) {
        super(props);
        this.GetSets = this.GetSets.bind(this);
        this.GetCards = this.GetCards.bind(this);
        this.onPreviousCardClick = this.onPreviousCardClick.bind(this);
        this.onNextCardClick = this.onNextCardClick.bind(this);
        this.addCard = this.addCard.bind(this);
        this.removeCard = this.removeCard.bind(this);
        this.setSetMenuItems = this.setSetMenuItems.bind(this);
        this.CheckLoginStatus = this.CheckLoginStatus.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);

        initializeIcons();

        let dev = false;
        let selectedSite = "";
        if (document.location.host === "localhost:3000") {
            dev = true;
            selectedSite = "retrocollectie";
        } else {
            const locparts = document.location.host.split('.');
            if (locparts[0].toLowerCase() === "admin") {
                selectedSite = locparts[1];
            } else {
                selectedSite = locparts[0].substring(5) + "." + locparts[1];
            }
        }

        let apiUrl =  document.location.origin + "/Backend";
        if (dev) {
            apiUrl = "http://127.0.0.1:36";
        }

        const username = cookie.load('username');
        const token = cookie.load('token');

        window.addEventListener("pageshow", function(event) {
            if (event.persisted) { //back button was used
                SetLoggedOut(apiUrl, username, token);
            }
        });

        window.addEventListener("beforeunload", function(e) {
            cookie.remove('token');
        });

        console.warn = console.error = () => { }; //disable warnings

        this.state = {
            apiUrl: apiUrl,
            username: username,
            token: token,
            loading: false,
            eurprice: 0,
            setvalue: 0,
            setsMenu: [],
            sets: [],
            setsCombobox: [],
            cardIndex: 0,
            cards: [],
            filteredcards: [],
            satprice: 0,
            saving: false,
            isDebug: Globals.GetParam('debug') ? true : false,
            dev: dev,
            selectedSetName: "",
            selectedSetId: 0,
            visibleTab: "",
            history: [],
            invoice: null,
            settotalcards: 0,
            site: selectedSite,
            onlyAvailable: false,
            sitemap: [],
            routes: "",
            commission: 0,
            showmax: 10,
            totalFiltered: 0,
            showFilters: window.innerWidth > 950 ? true : false,
            defaultTags: "" //Getest:bool:1|Status:string:Goed|Compleet:string:Alleen game|Versie:string:EUR
        }

        this.GetSets();
        this.GetConfig();
        this.CheckLoginStatus();
        this.GetCommission();
    }

    private async GetConfig() {
        fetch(`${this.state.apiUrl}/GetConfig?username=${this.state.username}&token=${this.state.token}&site=${this.state.site}`, {
                    method: 'GET',
                    mode: 'cors',
                }).then((response) => response.json()).then((data: TConfig[]) => {
                    data.forEach((d) => {
                        switch (d.name) {
                            case "PRODUCT_TAGS":
                                this.setState({defaultTags:d.value});
                                break;
                            default:
                                break;
                        }
                    })
                }).catch(err => {
                    console.log(err);
                });
    }

    private async GetCommission() {
        fetch(`${this.state.apiUrl}/GetCommission?username=${this.state.username}&token=${this.state.token}&site=${this.state.site}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data: string) => {
            this.setState({commission:Number(data)});
        }).catch(err => {
            console.log(err);
        });
    }

    private async CheckLoginStatus() {
        await fetch(`${this.state.apiUrl}/IsLoggedIn?site=retrocollectie&username=${this.state.username}&token=${this.state.token}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data) => {
            if (data.success === false) {
                this.logout();
            }
        });
        setTimeout(() => {
            this.CheckLoginStatus();
        }, 30000);
    }

    //TODO: start using globals getset
    private GetSets() {
        GetSets(this.state.dev, this.state.site).then(sets => {
            let options: IComboBoxOption[] = [];
            sets.forEach(set => {
                options.push({ key: set.id, text: set.name });
            });
            this.setState({ sets: sets, setsCombobox: options }, () => {
                this.setSetMenuItems(sets);
                //this.GetCards("SV: 151");
            });
        }).catch(err => {
            if (!this.state.dev) {
                console.log(err);
            }
        });
    }

    private async GetCards(setname?: string, currentCardId?: number) {
        let fullsiteurl = "";
        if (this.state.dev) {
            fullsiteurl = "http://localhost:3001";
        } else {
            fullsiteurl = "https://"+this.state.site + ".nl";
        }
        const setid = this.state.sets.filter(set => set.name === setname)[0].id;
        let settotalproducts = 0;

        if (this.state.site !== "pokemoncollectie") {
            await fetch(`${this.state.apiUrl}/productsv2?setid=${setid}&site=retrocollectie&username=${this.state.username}&token=${this.state.token}`, {
                method: 'GET',
                mode: 'cors',
            }).then((response) => response.json()).then((data) => {
                console.log({data});
                let products = data as TProduct[];
                let setvalue = 0;
                
                products.forEach(product => {
                    settotalproducts += product.available;
                    let imageUrls: string[] = [];
                    product.imageNames.split(',').forEach(imageName => {
                        if (imageName != "") {
                            imageUrls.push(`${fullsiteurl}/assets/products/${product.setID}/${product.id.toString()}/${imageName}`);
                        }
                    });
                    product.imageUrls = imageUrls;
                    setvalue = setvalue + (product.priceInEUR * product.available);
                });

                this.setState({ cards: products, setvalue: setvalue, settotalcards: settotalproducts, loading:false });
                let history = this.state.history;
                console.log(history);
                if (currentCardId && history.length > 0) {
                    const newstring = `${history[history.length - 1]} ${products.filter(c => c.id === currentCardId)[0].available.toString()}`;
                    history.pop();
                    history.push(newstring);
                }

                if (this.state.filter) {
                    let filteredProducts = products.filter(product => product.title.toLowerCase().indexOf(this.state.filter.toLowerCase()) !== -1);
                    this.setState({totalFiltered: filteredProducts.length, filteredcards : filteredProducts.length > this.state.showmax ? filteredProducts.slice(0,this.state.showmax) : filteredProducts, loading: false});
                } else {
                    this.setState({totalFiltered: products.length, filteredcards: products.length > this.state.showmax ? products.slice(0,this.state.showmax) : products});
                }
            });
        } else {
            this.GetEURPrice(this.state.dev).then(eurprice => {
                this.setState({ eurprice: eurprice });
            });
            
            await fetch(`${this.state.apiUrl}/cards?setname=${encodeURIComponent(setname ? setname : "")}&getAvailable=${true}&username=${this.state.username}&token=${this.state.token}&site=${this.state.site}`, {
                method: 'GET',
                mode: 'cors',
            }).then((response) => response.json()).then((data) => {
                let cards = data as TProduct[];
                let setvalue = 0;
                console.log({data});
                console.log({cards});
                cards.forEach(card => {
                    settotalproducts += card.available;

                    if (card.number > 99) {
                        card.scardnumber = `${card.number}`;
                    } else if (card.number > 9) {
                        card.scardnumber = `0${card.number}`;
                    } else {
                        card.scardnumber = `00${card.number}`;
                    }

                    //TODO: move to backend, minimale prijs toevoegen
                    card.priceInUSD = Math.round(card.priceInUSD * 100) / 100;
                    card.cost = Math.round(card.priceInUSD / this.state.satprice);
                    card.scost = `${card.cost}`;
                    if (!card.priceInEUR) {
                        card.priceInEUR = Math.round(card.priceInUSD * this.state.eurprice * 100) / 100;
                    }
                    card.setID = setid;
                    let imageUrls: string[] = [];
                    card.imageNames.split(',').forEach(imageName => {
                        imageUrls.push(`${fullsiteurl}/assets/pokemon/${card.setID}/${card.number.toString()}/${imageName}`);
                    });
                    card.imageUrls = imageUrls;
                    setvalue = setvalue + (card.priceInUSD * card.available);
                });
                this.setState({ cards: cards, setvalue: setvalue });
                let history = this.state.history;
                console.log(history);
                if (currentCardId && history.length > 0) {
                    const newstring = `${history[history.length - 1]} ${cards.filter(c => c.id === currentCardId)[0].available.toString()}`;
                    history.pop();
                    history.push(newstring);
                }
                const fcards = cards.filter(card => card.number === this.state.cardIndex);
                
                this.setState({totalFiltered: fcards.length, filteredcards: fcards.length > this.state.showmax ? fcards.slice(0,this.state.showmax) : fcards, settotalcards: settotalproducts, loading: false});
            });
        }
    }

    private onSelectedSet(event: FormEvent<IComboBox>, option?: IComboBoxOption | undefined, index?: number | undefined, value?: string | undefined) {
        this.setState({ selectedSetName: option.text });
        this.GetCards(option.text);
    }

    onSetSelectedBaseSet = (value?: string | number) => {
        this.setState({loading:true}, () => {
            const setid: number = value as number;
            let currentexpsets = this.state.sets.filter(set => set.id === setid);
            this.setState({ selectedSetId: setid, selectedSetName: currentexpsets[0].name });
            this.GetCards(currentexpsets[0].name);
        });
    }

    private async generate() {
        await fetch(`${this.state.apiUrl}/UpdateSitemap?username=${this.state.username}&site=${this.state.site}&token=${this.state.token}`, {
            method: 'GET',
        }).then((response) => response.json()).then((data:string[]) => {
            this.setState({sitemap: data, message: "De sitemap is vernieuwd."});
        });

        this.setState({loading:false});
    }

    private onPreviousCardClick() {
        const newcardIndex = this.state.cardIndex - 1;
        const cards = this.state.cards.filter(card => card.number === newcardIndex);
        this.setState({ cardIndex: newcardIndex, filteredcards: cards.length > this.state.showmax ? cards.splice(0,this.state.showmax) : cards });
    }

    private onNextCardClick() {
        const newcardIndex = this.state.cardIndex + 1;
        const cards = this.state.cards.filter(card => card.number === newcardIndex);
        this.setState({ cardIndex: newcardIndex, filteredcards: cards.length > this.state.showmax ? cards.splice(0,this.state.showmax) : cards });
    }

    private async addCard(card: TProduct) {
        await fetch(`${this.state.apiUrl}/AddCard?cardid=${encodeURIComponent(card.id)}&username=${this.state.username}&token=${this.state.token}&site=${this.state.site}`, {
            method: 'GET',
        }).then((response) => response.json()).then((data) => {
            if (data === false) {
                //console.log(data);
                this.setState({errormessage:"Kaart update gefaaald!"});
            } else {
                let parts = data.split(',');
                let history = this.state.history;
                parts.forEach(p => {
                    history.push(p);
                });
                history.push(`${card.name} ${card.title} ${card.available}, nieuwe hoeveelheid: `);
                this.GetCards(this.state.selectedSetName, card.id);
            }
        });
    }

    private setSetMenuItems(sets: TSet[]) {
        this.setState({ setsMenu: CreateSetMenu(sets, this.state.selectedSetId, this.onSetSelectedBaseSet, this.onSetSelectedBaseSet) });
    }

    private async removeCard(card: TProduct) {
        await fetch(`${this.state.apiUrl}/RemoveCard?cardid=${encodeURIComponent(card.id)}&username=${this.state.username}&token=${this.state.token}&site=${this.state.site}`, {
            method: 'GET',
        }).then((response) => response.json()).then((data) => {
            if (data === true) {
                let history = this.state.history;
                history.push(`${card.name} ${card.title} ${card.available}, nieuwe hoeveelheid: `);
                this.GetCards(this.state.selectedSetName, card.id);
            } else {
                console.log(data);
                this.setState({errormessage:"Kaart update gefaaald!"});
            }
        });
    }

    private GetEURPrice(isDev: boolean = false) {
        return fetch(`https://${this.state.site}.nl/Backend/EURPrice?username=${this.state.username}&token=${this.state.token}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data) => data as number);
    }

    SetMessage = (message: string) => {
        this.setState({ toastMessage: message });
    }

    procuctsSelected = () => {
        this.GetSets();
        this.setState({ visibleTab: 'Producten'});
    }

    addProduct = async (product: TProduct) => {
        await fetch(`${this.state.apiUrl}/AddProductv2?productid=${product.id}&site=${this.state.site}&username=${this.state.username}&token=${this.state.token}`, {
            method: 'GET',
        }).then((response) => response.json()).then((data) => {
            if (data === false) {
                //console.log(data);
                this.setState({errormessage:"Kaart update gefaaald!"});
            } else {
                let parts = data.split(',');
                let history = this.state.history;
                parts.forEach(p => {
                    history.push(p);
                });
                history.push(`${this.state.selectedSetName} ${product.title} ${product.available}, nieuwe hoeveelheid: `);
                this.GetCards(this.state.selectedSetName, product.id);
            }
        });
    }

    removeProduct = async (product: TProduct) => {
        await fetch(`${this.state.apiUrl}/RemoveProductv2?productid=${product.id}&site=${this.state.site}&username=${this.state.username}&token=${this.state.token}`, {
            method: 'GET',
        }).then((response) => response.json()).then((data) => {
            if (data === true) {
                let history = this.state.history;
                history.push(`${this.state.selectedSetName} ${product.title} ${product.available}, nieuwe hoeveelheid: `);
                this.GetCards(this.state.selectedSetName, product.id);
            } else {
                console.log(data);
                this.setState({errormessage:"Kaart update gefaaald!"});
            }
        });
    }

    onFilterChange = (e,filter) => {
        console.log(filter);
        if (filter?.length > 2 || filter?.length === 0) {
            let filtered = this.state.cards.filter(card => card.title?.toLowerCase().indexOf(filter?.toLowerCase()) !== -1);
            if (this.state.onlyAvailable) {
                filtered = filtered.filter(f => f.available > 0);
            }
            this.setState({totalFiltered: filtered.length, filteredcards : filtered.length > this.state.showmax ? filtered.slice(0,this.state.showmax): filtered});
        } 
        this.setState({filter: filter, loading: false});
    }

    onOnlyAvailable = (e,c) => {
        if (c) {
            let filtered = this.state.cards.filter(card => card.available > 0);
            this.setState({totalFiltered: filtered.length, onlyAvailable: c, loading: false, filteredcards : filtered.length > this.state.showmax ? filtered.slice(0,this.state.showmax): filtered, filter: ""});
        } else {
            this.setState({totalFiltered: this.state.cards.length, onlyAvailable: c, loading: false, filteredcards : this.state.cards.length > this.state.showmax ? this.state.cards.slice(0,this.state.showmax) : this.state.cards, filter: ""});
        }
    }

    productsReload = (setFilter: string = undefined) : Promise<void> => {
        return new Promise( async (resolve, reject) => {
            const setid = this.state.selectedSetId;
            let currentexpsets = this.state.sets.filter(set => set.id === setid);
            this.setState({ newProduct: undefined, selectedSetId: setid, selectedSetName: currentexpsets[0].name, filter: setFilter ? setFilter : this.state.filter }, async () => {
                await this.GetCards(currentexpsets[0].name);
                this.onFilterChange(null, this.state.filter);
                if (this.state.onlyAvailable) {
                    this.onOnlyAvailable(null, this.state.onlyAvailable);
                }
                resolve();
            });
        });
    }

    newProduct = () => {
        //defaultTags: "" //Getest:bool:1|Status:string:Goed|Compleet:string:Alleen game|Versie:string:EUR
        this.setState({newProduct: {
            available: 1,
            setID: this.state.selectedSetId,
            tags: "Getest$:$1|Status$:$Goed|Compleet$:$Ja",
            imageNames: "",
            imageUrls: [],
            priceInEUR: 0,
            id: 0,
            order: 0,
            description: "",
            type: ''
        }});
    }

    logout = () => {
        cookie.remove('token');
        SetLoggedOut(this.state.apiUrl, this.state.username, this.state.token);
        this.setState({token: null});
        window.location.replace(window.location.origin);
    }

    setconfirmCallback(f: Function) {
        this.setState({confirmCallback: f});
    }

    public render(): React.ReactElement<IaddCardsProps> {
        console.log(this.state);
        return (
            <div>
                <Dialog
                    hidden={!this.state.confirmCallback}
                    dialogContentProps={{ type: DialogType.normal }}
                    onDismiss={() => { this.setState({confirmCallback: undefined}) }}
                    modalProps={{ styles: { main: { maxHeight: "100%!important", width: 800, height: 800, maxWidth: "100%!important", backgroundColor: "transparent", boxShadow: "none", overflowY: "auto" } } }}
                >
                    <Stack horizontalAlign='center' style={{backgroundColor:"white",padding:20}}>
                        <Label>Weet u zeker dat u wilt opslaan?</Label>
                        <Stack horizontal>
                            <DefaultButton text="Nee" onClick={() => {this.setState({confirmCallback: undefined})}} />
                            <PrimaryButton text="Ja" onClick={() => { this.state.confirmCallback(); }} />
                        </Stack>
                    </Stack>
                </Dialog>
                {this.state.loading && <Stack verticalAlign='center' style={{position:"absolute",width:"100%",height:"100%",zIndex:2, backgroundColor:"rgba(0, 0, 0, 0.2)"}}><Spinner size={SpinnerSize.large} style={{zIndex:4}} label="Loading..." /></Stack>}
                <Stack horizontalAlign='end'>
                    <PrimaryButton style={{ margin: 5 }} text='Uitloggen' onClick={this.logout.bind(this)} />
                </Stack>
                <ShowToastComponent message={this.state.errormessage ? this.state.errormessage : this.state.message} 
                                    isError={this.state.errormessage ? true : false} 
                                    timeout={2000} callback={() => {
                                    this.setState({message:undefined,errormessage:undefined});
                }} />
                <Stack horizontal horizontalAlign='center'>
                    {this.state.site === "pokemoncollectie" ?
                        <img src='https://pokemoncollectie.nl/assets/pokemon%20kaarten.webp?v=3' style={{ cursor: "pointer", maxWidth: "50%" }} />
                        :
                        <img src={`https://${this.state.site}.nl/assets/sitebanner.png?v=1`} style={{ cursor: "pointer", maxWidth: "50%" }} />
                    }
                </Stack>
                {this.state.site === "pokemoncollectie" ? 
                <div>
                    <Stack style={{ backgroundColor: "lightblue", width: "100%", padding: 15, display:"block" }} tokens={{ childrenGap: 10 }} horizontal horizontalAlign='center'>
                        <PrimaryButton style={{ margin: 5 }} text='Kaarten' onClick={() => { this.setState({ visibleTab: 'Kaarten' }) }} />
                        <PrimaryButton style={{ margin: 5 }} text='Producten toevoegen / verwijderen' onClick={() => { this.setState({ visibleTab: 'Producten' }) }} />
                        <PrimaryButton style={{ margin: 5 }} text='Bestelling bekijken' onClick={() => { this.setState({ visibleTab: 'Bestelling' }) }} />
                        <PrimaryButton style={{ margin: 5 }} text='Sitemap' onClick={() => { this.setState({ visibleTab: 'Sitemap' }) }} />
                        <PrimaryButton style={{ margin: 5 }} text='Set manager' onClick={() => { this.setState({ visibleTab: 'SetManager' }) }} />
                        <PrimaryButton style={{ margin: 5 }} text='Verbindingen bekijken' onClick={() => { this.setState({ visibleTab: 'Verbinding' }) }} />
                        <PrimaryButton style={{ margin: 5 }} text='Logs bekijken' onClick={() => { this.setState({ visibleTab: 'Logs' }) }} />
                    </Stack>
                    {this.state.visibleTab === "Sitemap" && 
                        <Stack style={{paddingLeft:10, width:"100%"}}>
                            <h3>Update Sitemap</h3>
                            <table style={{width:"100%",height:"100%"}}>
                                <tr>
                                    <td>
                                        <PrimaryButton text="Update Sitemap.xml" onClick={() => { this.generate(); }} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <TextField label='Sitemap' multiline resizable rows={40} value={this.state.sitemap.join('\n')}/>
                                    </td>
                                </tr>
                            </table>
                        </Stack>}
                    {this.state.visibleTab === 'SetManager' && <div>
                        <SetManager site={this.state.site} apiUrl={this.state.apiUrl} dev={this.state.dev} sets={this.state.sets} token={this.state.token} username={this.state.username}/>
                    </div>}
                    {this.state.visibleTab === 'Verbinding' && <div>
                        <Connects apiUrl={this.state.apiUrl} username={this.state.username} token={this.state.token} site={this.state.site} />
                    </div>}
                    {this.state.visibleTab === 'Bestelling' && <div>
                        <Clients apiUrl={this.state.apiUrl} dev={this.state.dev} site={this.state.site} username={this.state.username} token={this.state.token} />
                    </div>}
                    {this.state.visibleTab === 'Producten' && <div>
                        <Products apiUrl={this.state.apiUrl} 
                                  ShowMessage={this.SetMessage} 
                                  dev={this.state.dev} 
                                  sets={this.state.sets} 
                                  site={this.state.site}
                                  token={this.state.token}
                                  username={this.state.username}/>
                    </div>}
                    {this.state.visibleTab === 'Logs' && <div>
                        <Logs dev={this.state.dev} apiUrl={this.state.apiUrl} username={this.state.username} token={this.state.token} site={this.state.site} />
                    </div>}
                    <ShowToastComponent message={this.state.toastMessage} isError={false} timeout={2000} callback={() => { this.setState({ toastMessage: undefined }); }} />
                    <Stack horizontal={false}>
                        <Stack tokens={{ childrenGap: 20, padding: 10 }}>
                            {this.state.visibleTab === 'Kaarten' && <div>
                                <h1>{this.state.selectedSetName}</h1>
                                <h2>Aantal kaarten beschikbaar: {this.state.settotalcards}</h2>
                                <h2>Totaal set waarde: €{parseFloat((this.state.setvalue * this.state.eurprice).toString()).toFixed(2)}</h2>
                                <Stack horizontal>
                                    <Stack horizontal={false}>
                                        <Stack horizontal>
                                            <div className={styles.divTable}>
                                                <div className={styles.divTableRow}>
                                                    <div className={styles.divTableCell}>
                                                        <Label>Set</Label>
                                                    </div>
                                                    <div className={styles.divTableCell}>
                                                        <Stack>
                                                            <DefaultButton className={styles.setSelector} text={this.state.sets.find(set => set.id == this.state.selectedSetId)?.name} menuProps={{ items: this.state.setsMenu, shouldFocusOnMount: true, subMenuHoverDelay: 250 }} />
                                                        </Stack>
                                                    </div>
                                                </div>
                                                <div className={styles.divTableRow}>
                                                    <div className={styles.divTableCell}>
                                                        <Label>Kaart nummer</Label>
                                                    </div>
                                                    <div className={styles.divTableCell}>
                                                        <Stack horizontal>
                                                            <PrimaryButton text='<' onClick={() => { this.onPreviousCardClick(); }} />
                                                            <TextField value={this.state.cardIndex.toString()} onChange={(e, v) => {
                                                                const cards = this.state.cards.filter(card => card.number === Number(v));
                                                                this.setState({ cardIndex: Number(v), filteredcards: cards.length > this.state.showmax ? cards.splice(0,this.state.showmax) : cards });
                                                            }} />
                                                            <PrimaryButton text='>' onClick={() => { this.onNextCardClick(); }} />
                                                        </Stack>
                                                    </div>
                                                </div>
                                            </div>
                                        </Stack>
                                        <Stack horizontal>
                                            {this.state.filteredcards.map(card => {
                                                return <PokemonCards addCard={this.addCard} removeCard={this.removeCard} saving={this.state.saving} card={card} onBuyClick={undefined} satprice={0} onImageClick={undefined} animationsEnabled={false} eurprice={0} hideSwipe={false} />
                                            })}
                                        </Stack>
                                    </Stack>
                                    <Stack>
                                        {this.state.history.map(his => {
                                            return <div style={{ whiteSpace: "nowrap" }}>{his}</div>
                                        })}
                                    </Stack>
                                </Stack>
                            </div>}
                        </Stack>
                    </Stack>
                </div>
                : //other collecties
                <div>
                    <Stack style={{ backgroundColor: "lightblue", width: "100%", padding: 15, display:"block" }} tokens={{ childrenGap: 10 }} horizontal horizontalAlign='center'>
                        <PrimaryButton style={{ margin: 5 }} text='Instellingen' onClick={() => { this.GetSets(); this.setState({ visibleTab: 'Settings'}); }}/>
                        <PrimaryButton style={{ margin: 5 }} text='Producten' onClick={() => { this.GetSets(); this.setState({ visibleTab: 'Producten'}); }}/>
                        <PrimaryButton style={{ margin: 5 }} text='Sets (categoriën)' onClick={() => { this.GetSets(); this.setState({ visibleTab: 'Sets' }) }}/>
                        <PrimaryButton style={{ margin: 5 }} text='Sitemap' onClick={() => { this.setState({ visibleTab: 'Sitemap' }) }} />
                        <PrimaryButton style={{ margin: 5 }} text='Bestelling bekijken' onClick={() => { this.setState({ visibleTab: 'Bestelling' }) }} />
                        {this.state.site === "retrocollectie" && <PrimaryButton style={{ margin: 5 }} text='Verbindingen bekijken' onClick={() => { this.setState({ visibleTab: 'Verbinding' }) }} />}
                        <PrimaryButton style={{ margin: 5 }} text='Styling' onClick={() => { this.setState({ visibleTab: 'Styling' }) }} />
                        {this.state.site === "retrocollectie" && <PrimaryButton style={{ margin: 5 }} text='Configuratie' onClick={() => { this.setState({ visibleTab: 'Configuratie' }) }} />}
                    </Stack>
                    {this.state.visibleTab === 'Settings' && <div>
                        <Settings Sets={this.state.sets} 
                                  site={this.state.site} 
                                  token={this.state.token} 
                                  username={this.state.username} 
                                  apiUrl={this.state.apiUrl}
                                  setMessage={(m:string) => { this.setState({message:m}); }} 
                                  setError={(m:string) => { this.setState({errormessage:m}) }}/>
                    </div>}
                    {this.state.visibleTab === 'Sets' && <div>
                        <SetManagerV2 Sets={this.state.sets} token={this.state.token} site={this.state.site} username={this.state.username} apiUrl={this.state.apiUrl} setMessage={(m:string) => { this.setState({message:m}); }} setError={(m:string) => { this.setState({errormessage:m}); }} />
                    </div>}
                    {this.state.visibleTab === 'Configuratie' && <div>
                        <Configuration token={this.state.token} 
                                       site={this.state.site} 
                                       username={this.state.username} 
                                       apiUrl={this.state.apiUrl} 
                                       setMessage={(m:string) => { this.setState({message:m}); }} 
                                       setError={(m:string) => { this.setState({errormessage:m}) }}
                                       setConfirm={this.setconfirmCallback.bind(this)} />
                    </div>}
                    {this.state.visibleTab === 'Styling' && <div>
                        <Styling token={this.state.token} site={this.state.site} username={this.state.username} apiUrl={this.state.apiUrl} setMessage={(m:string) => { this.setState({message:m}); }} setError={(m:string) => { this.setState({errormessage:m}); }}/>
                    </div>}
                    {this.state.visibleTab === 'Verbinding' && <div>
                        <Connects apiUrl={this.state.apiUrl} username={this.state.username} token={this.state.token} site={this.state.site}/>
                    </div>}
                    {this.state.visibleTab === 'Bestelling' && <div>
                        <Clientsv2 apiUrl={this.state.apiUrl} 
                                   commission={this.state.commission}
                                   token={this.state.token}
                                   username={this.state.username}
                                   dev={this.state.dev} 
                                   site={this.state.site} />
                    </div>}
                    {this.state.visibleTab === "Sitemap" && 
                    <Stack style={{paddingLeft:10, width:"100%"}}>
                        <h3>Update Sitemap</h3>
                        <table style={{width:"100%",height:"100%"}}>
                            <tr>
                                <td>
                                    <PrimaryButton text="Update Sitemap.xml" onClick={() => { this.generate(); }} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <TextField label='Sitemap' multiline resizable rows={40} value={this.state.sitemap.join('\n')}/>
                                </td>
                            </tr>
                        </table>
                    </Stack>}
                    {this.state.visibleTab === 'Producten' && <Stack horizontal={false}>
                        <Stack tokens={{ childrenGap: 20, padding: 10 }}>
                            <div>
                                <Stack horizontal>
                                    <Stack style={{width:"100%", display:"block"}}>
                                        <Stack horizontal verticalAlign='start' tokens={{ padding: 10, childrenGap: window.innerWidth < 960 ? 0 : 20}} style={{width:"100%", display:window.innerWidth < 960 ? "block" : "flex"}}>
                                            <Stack horizontalAlign='start' verticalAlign='start' style={{border:"1px solid blue", padding: 5, margin: 5}}>
                                                <Label style={{fontWeight:"bold"}}>Acties</Label>
                                                <Label>Set</Label>
                                                <DefaultButton label="Set" className={styles.setSelector} text={this.state.sets.find(set => set.id == this.state.selectedSetId)?.name} menuProps={{ items: this.state.setsMenu, shouldFocusOnMount: true, subMenuHoverDelay: 250 }} />
                                                <Stack>
                                                    <Label>Nieuw</Label>
                                                    <PrimaryButton disabled={this.state.selectedSetId ? false : true} text="Nieuw product" onClick={this.newProduct}/>
                                                </Stack>
                                            </Stack>
                                            <Stack style={{border:"1px solid blue", padding: 5, margin: 5}}>
                                                <Stack horizontal onClick={() => {this.setState({showFilters: !this.state.showFilters})}} verticalAlign='center' >
                                                    <IconButton iconProps={{iconName: this.state.showFilters ? 'Hide' : "View"}} />
                                                    &nbsp;
                                                    <Label style={{fontWeight:"bold", cursor:"pointer"}}>Filters</Label>
                                                </Stack>
                                                {this.state.showFilters && <Stack>
                                                                            <Stack horizontal>
                                                                                <Label>Alleen beschikbaar</Label>
                                                                                <Checkbox onChange={(e,v) => { this.setState({loading:true}, () => { this.onOnlyAvailable(e,v); }); }} />
                                                                            </Stack>
                                                                            <Stack>
                                                                                <Label>Maximaal zichtbaar</Label>
                                                                                <Stack horizontal>
                                                                                    <span style={{border:"1px solid blue", cursor:"pointer", backgroundColor: this.state.showmax === 10 ? "lightblue" : "transparent", paddingLeft:5, paddingRight:5}} onClick={()=>{this.setState({showmax: 10}, () => { this.onFilterChange(null,""); })}}>10</span>
                                                                                    <span style={{border:"1px solid blue", cursor:"pointer", backgroundColor: this.state.showmax === 25 ? "lightblue" : "transparent", paddingLeft:5, paddingRight:5, marginLeft:5}} onClick={()=>{this.setState({showmax: 25}, () => { this.onFilterChange(null,""); })}}>25</span>
                                                                                    <span style={{border:"1px solid blue", cursor:"pointer", backgroundColor: this.state.showmax === 50 ? "lightblue" : "transparent", paddingLeft:5, paddingRight:5, marginLeft:5}} onClick={()=>{this.setState({showmax: 50}, () => { this.onFilterChange(null,""); })}}>50</span>
                                                                                    <span style={{border:"1px solid blue", cursor:"pointer", backgroundColor: this.state.showmax === 100 ? "lightblue" : "transparent", paddingLeft:5, paddingRight:5, marginLeft:5}} onClick={()=>{this.setState({showmax: 100}, () => { this.onFilterChange(null,""); })}}>100</span>
                                                                                    <span style={{border:"1px solid blue", cursor:"pointer", backgroundColor: this.state.showmax === 250 ? "lightblue" : "transparent", paddingLeft:5, paddingRight:5, marginLeft:5}} onClick={()=>{this.setState({showmax: 250}, () => { this.onFilterChange(null,""); })}}>250</span>
                                                                                    <span>&nbsp;van {this.state.totalFiltered}</span>
                                                                                </Stack>
                                                                            </Stack>
                                                                            <TextField label="Filter" value={this.state.filter} onChange={(e,f) => { this.setState( {loading:true}, () => { this.onFilterChange(e,f); } ); }} />
                                                                           </Stack>}
                                            </Stack>    
                                            <EditTags defaultTags={this.state.defaultTags} />
                                        </Stack>
                                        <hr />
                                        {this.state.selectedSetName && <Stack horizontal>
                                            <h2>Producten beschikbaar: {this.state.settotalcards} , Set waarde: €{parseFloat(this.state.setvalue.toString()).toFixed(2)}</h2>
                                        </Stack>}
                                        <hr />
                                        <div style={{maxWidth:window.innerWidth}}>
                                            {this.state.newProduct ? 
                                                <div style={window.innerWidth < 960 ? {} : {float:"left"}}>
                                                            <ProductsComponent reload={this.productsReload.bind(this)} 
                                                                               token={this.state.token}
                                                                               site={this.state.site}
                                                                               username={this.state.username}
                                                                               apiUrl={this.state.apiUrl}
                                                                               addCard={this.addProduct} 
                                                                               removeCard={this.removeProduct} 
                                                                               saving={this.state.saving} 
                                                                               product={this.state.newProduct} 
                                                                               onBuyClick={undefined} 
                                                                               satprice={0} 
                                                                               onImageClick={undefined} 
                                                                               animationsEnabled={false} 
                                                                               eurprice={0} 
                                                                               commission={this.state.commission}
                                                                               hideSwipe={false} 
                                                                               selectedSite={this.state.site} 
                                                                               dev={this.state.dev}
                                                                               setMessage={(m:string) => { this.setState({message:m}); }} 
                                                                               setError={(m:string) => { this.setState({errormessage:m}); }} />
                                                </div>
                                            :
                                            this.state.filteredcards.map(card => {
                                                return <div style={window.innerWidth < 960 ? {} : {float:"left"}}>
                                                            <ProductsComponent reload={this.productsReload.bind(this)} 
                                                                               token={this.state.token}
                                                                               site={this.state.site}
                                                                               username={this.state.username}
                                                                               apiUrl={this.state.apiUrl}
                                                                               addCard={this.addProduct} 
                                                                               removeCard={this.removeProduct} 
                                                                               saving={this.state.saving} 
                                                                               product={card} 
                                                                               onBuyClick={undefined} 
                                                                               satprice={0} 
                                                                               onImageClick={undefined} 
                                                                               animationsEnabled={false} 
                                                                               commission={this.state.commission}
                                                                               eurprice={0} 
                                                                               hideSwipe={false} 
                                                                               selectedSite={this.state.site} 
                                                                               dev={this.state.dev}
                                                                               setMessage={(m:string) => { this.setState({message:m}); }} 
                                                                               setError={(m:string) => { this.setState({errormessage:m}); }} />
                                                       </div>
                                            })}
                                        </div>
                                    </Stack>
                                </Stack>
                            </div>
                        </Stack>
                    </Stack>}
                </div>}
            </div>
        );
    }
}